import mrpStyles from './../mrp.json'

export default {
  name: 'B4',
  type: 'Heading',
  color: mrpStyles.colors.SecondaryGreyMetal
}
